import { render } from "./Specialties.vue?vue&type=template&id=2396e342&scoped=true&lang=pug"
import script from "./Specialties.vue?vue&type=script&lang=js"
export * from "./Specialties.vue?vue&type=script&lang=js"

import "./Specialties.vue?vue&type=style&index=0&id=2396e342&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2396e342"]])

export default __exports__